import SignDocument from './SignDocument/SignDocument';
import SimpleSignDocuments from '../SimpleSignDocuments/SimpleSignDocuments';

const Routes = { SignDocument, SimpleSignDocuments };

export default Routes;



// WEBPACK FOOTER //
// ./src/containers/routes/index.js